import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * DocumentFooter — shared branded footer for all Eqaya documents.
 *
 * Props:
 *  documentType — human-readable document type, e.g. "proposal", "milestone report"
 */
const DocumentFooter = ({ documentType = 'document' }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mt: 8,
        pt: 3,
        borderTop: '2px solid #eee',
        color: 'text.secondary',
      }}
    >
      <Typography variant="caption" display="block">
        This {documentType} is generated by Eqaya (Private) Limited
      </Typography>
      <Typography variant="caption" display="block">
        info@eqaya.com · www.eqaya.com
      </Typography>
      <Typography variant="caption" display="block">
        Africa's trusted construction marketplace
      </Typography>
      <Typography variant="caption" display="block" sx={{ mt: 0.5, fontSize: '0.65rem' }}>
        Governed by the laws of Zimbabwe
      </Typography>
    </Box>
  );
};

export default DocumentFooter;
